"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var BugReport = function BugReport(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/technology/bug_report-bug-report" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "simplified_icons-technology-bug-report-bug-report" + unique,
    xlinkHref: "#path-1-bug-report" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-bug-report" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.38138513,6.39390844 L7.61864472,4.50926551 C7.27965315,4.14683094 7.29954058,3.57903624 7.66306452,3.24106053 C8.02658847,2.90308483 8.59608981,2.92291266 8.93508138,3.28534723 L10.7476237,5.22323616 C11.1577167,5.00352869 11.5751755,4.89367495 12,4.89367495 C12.4495212,4.89367495 12.8907953,5.01667236 13.3238223,5.2626672 L15.1732452,3.28534723 C15.5122368,2.92291266 16.0817382,2.90308483 16.4452621,3.24106053 C16.808786,3.57903624 16.8286735,4.14683094 16.4896819,4.50926551 L14.669551,6.45526777 C15.0204142,6.88251026 15.3653991,7.39742101 15.7045058,8 L20.5,8 C20.7761424,8 21,8.22385763 21,8.5 L21,9.5 C21,9.77614237 20.7761424,10 20.5,10 L16.6743041,10 C16.9337733,10.6117075 17.1895574,11.2783741 17.4416565,12 L20.5,12 C20.7761424,12 21,12.2238576 21,12.5 L21,13.5 C21,13.7761424 20.7761424,14 20.5,14 L18.0887899,14 C18.1594984,14.2350752 18.2299018,14.4747016 18.3,14.7188794 C18.3,15.1578955 18.2548245,15.586392 18.1688553,16 L20.5,16 C20.7761424,16 21,16.2238576 21,16.5 L21,17.5 C21,17.7761424 20.7761424,18 20.5,18 L17.3731467,18 C16.2652133,19.7996448 14.273207,21 12,21 C9.72679302,21 7.7347867,19.7996448 6.62685333,18 L3.5,18 C3.22385763,18 3,17.7761424 3,17.5 L3,16.5 C3,16.2238576 3.22385763,16 3.5,16 L5.83114465,16 C5.74517551,15.586392 5.7,15.1578955 5.7,14.7188794 C5.7700982,14.4747016 5.84050157,14.2350752 5.9112101,14 L3.5,14 C3.22385763,14 3,13.7761424 3,13.5 L3,12.5 C3,12.2238576 3.22385763,12 3.5,12 L6.55834346,12 C6.81044256,11.2783741 7.06622672,10.6117075 7.32569594,10 L3.5,10 C3.22385763,10 3,9.77614237 3,9.5 L3,8.5 C3,8.22385763 3.22385763,8 3.5,8 L8.29549421,8 C8.65099743,7.36828505 9.01296107,6.83292119 9.38138513,6.39390844 Z M9.5,13.9850164 C9.22385763,13.9850164 9,14.208874 9,14.4850164 L9,15.4850164 C9,15.7611588 9.22385763,15.9850164 9.5,15.9850164 L14.5,15.9850164 C14.7761424,15.9850164 15,15.7611588 15,15.4850164 L15,14.4850164 C15,14.208874 14.7761424,13.9850164 14.5,13.9850164 L9.5,13.9850164 Z M9.5,9.98501638 C9.22385763,9.98501638 9,10.208874 9,10.4850164 L9,11.4850164 C9,11.7611588 9.22385763,11.9850164 9.5,11.9850164 L14.5,11.9850164 C14.7761424,11.9850164 15,11.7611588 15,11.4850164 L15,10.4850164 C15,10.208874 14.7761424,9.98501638 14.5,9.98501638 L9.5,9.98501638 Z",
    fill: "inherit",
    id: "path-1-bug-report" + unique
  }))));
};

BugReport.propTypes = propTypes;
var _default = BugReport;
exports["default"] = _default;